/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ListResultsParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 200
 */
per_page?: number;
/**
 * Comma-separated columns: match, criterion_{uuid}
 */
sort_by?: string;
/**
 * Comma-separated directions: asc, desc
 */
sort_order?: string;
/**
 * Filter results by candidate name (case-insensitive).
 */
q?: string | null;
};
